import React, { useState, useEffect } from "react";
import Widgets from "../../../../widgets";
import { useTranslation } from "react-i18next";
import strings from "../../../../utils/strings";
import Icons from "../../../../Assets/Icons";
import "./AdditionalConsumableList.css";
import { useNavigate, useLocation } from "react-router-dom";
import queryString from "query-string";
import { useDispatch, useSelector } from "react-redux";
import { getAddConsumableList } from "../../../../modules/NursignCare/AdditonalConsumable/AddConsumableThunk";
import { resetGetAddConsumableList } from "../../../../modules/NursignCare/AdditonalConsumable/AddConsumableSlice";
import ToastPopup from "../../../../widgets/Toast/toastPopup";

const AdditionalConsumableList = () => {
  const dispatch = useDispatch();
  const { addConsumableListSuccess, addConsumableListErr } = useSelector((state) => state.addConsumable);
  const { t } = useTranslation();
  const nav = useNavigate();
  const location = useLocation();
  const breadcrumbs = ["nursingCare", "manageResource"];
  const paths = [strings.navigation.manageNurseReq, location.pathname];
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(null);
  const [isNameHovered, setIsNameHovered] = useState(false);
  const [consumableList, setConsumableList] = useState({});
  const itemsPerPage = 1;
  const [searchh, setSearch] = useState(null);

  const fetchGetConsumable = (pageNumber = currentPage, limit = itemsPerPage, searchFields = "departmentName", search = searchh) => {
    let page = pageNumber ?? currentPage ?? 1;
    dispatch(getAddConsumableList({ page, limit, search, searchFields }));
  };

  useEffect(() => {
    fetchGetConsumable();
  }, []);

  useEffect(() => {
    if (typeof searchh === "string") {
      fetchGetConsumable(1);
    }
  }, [searchh]);

  useEffect(() => {
    if (addConsumableListErr) {
      ToastPopup.error(addConsumableListErr);
    }
    if (addConsumableListSuccess && addConsumableListSuccess.status === "success") {
      console.log(addConsumableListSuccess.data.consumables);
      setConsumableList(addConsumableListSuccess.data.consumables);
      setTotalPages(addConsumableListSuccess.data.totalPages);
      setCurrentPage(addConsumableListSuccess.data.currentPage);
    }
    dispatch(resetGetAddConsumableList());
  }, [addConsumableListSuccess, addConsumableListErr]);

  const renderPagination = () => {
    const pages = [];
    if (totalPages <= 4) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 2) {
        pages.push(1, 2, { type: "ellipsis" }, totalPages);
      } else if (currentPage >= totalPages - 1) {
        pages.push(1, { type: "ellipsis" }, totalPages - 1, totalPages);
      } else {
        pages.push(1, { type: "ellipsis" }, currentPage, { type: "ellipsis" }, totalPages);
      }
    }
    return pages;
  };

  const handleClick = (pageNumber) => {
    fetchGetConsumable(pageNumber);
  };

  const handlePrevNext = (direction) => {
    if (direction === "prev" && currentPage > 1) {
      fetchGetConsumable(currentPage - 1);
    } else if (direction === "next" && currentPage < totalPages) {
      fetchGetConsumable(currentPage + 1);
    }
  };

  const handleVerifyClick = (item) => {
    const flattened = {
      ...item,
      ...item.price,
      groupName: item.group.group,
      groupId: item.group._id,
    };
    delete flattened.price;
    delete flattened.group;
    const queryParams = queryString.stringify(flattened, { encode: true });
    nav(`${strings.navigation.editConsumable}?${queryParams}`);
  };

  const truncateText = (text) => {
    if (text.length > 30) {
      return text.slice(0, 30) + "...";
    }
    return text;
  };

  const handleMouseEnter = () => {
    setIsNameHovered(true);
  };

  const handleMouseLeave = () => {
    setIsNameHovered(false);
  };

  const handleSearch = (query) => {
    setSearch(query);
  };

  return (
    <div className="dp-container">
      <Widgets.BreadCrumb breadcrumbs={breadcrumbs} paths={paths} />
      <div className="department-heading">{t("additionalConsumables")}</div>
      <div className="department-search-line">
        <Widgets.SearchBox onSearch={handleSearch} placeholder={"searchByCodeName"} />
        <Widgets.IconButton iconSrc={Icons.plusIconGreen} buttonText="createConsumable" onClick={() => nav(strings.navigation.addConsumable)} />
      </div>
      <div className="dp-list-box">
        <div className="dp-secondary-box">
          <div className="dp-price-box">
            <table className="dp-price-layout">
              <thead className="dp-thead">
                <tr>
                  <th>{t("groupName")}</th>
                  <th>{t("code")}</th>
                  <th>{t("name")}</th>
                  <th>{t("stockUOM")}</th>
                </tr>
              </thead>
              <tbody className="dp-tbody">
                {consumableList.length > 0 &&
                  consumableList.map((item, index) => (
                    <tr key={index} className="acl-table-row" onClick={() => handleVerifyClick(item)}>
                      <td>{item?.group?.group}</td>
                      <td>{item.code}</td>
                      <td className="acl-name-list" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                        {truncateText(item.itemName)}
                        {isNameHovered && <div className="acl-name-list-hover">{item.itemName}</div>}
                      </td>
                      <td>{item.stockUOM}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
            {totalPages === 0 && (
              <div className="no-record-container">
                <div className="no-record-icon">
                  <img src={Icons.NoData} alt="No Data Found" />
                </div>
                <div className="no-record-text">{t("noRecordFound")}</div>
              </div>
            )}
          </div>
          <div className="department-pagination-list">
            {totalPages > 0 && (
              <>
                <button onClick={() => handlePrevNext("prev")} disabled={currentPage === 1} className="department-pagination-prev-list">
                  <img src={Icons.leftArrow} alt="<" />
                </button>
                {renderPagination().map((page, index) => (
                  <button
                    key={index}
                    onClick={() => typeof page === "number" && handleClick(page)}
                    disabled={page === currentPage || page.type === "ellipsis"}
                    className={`department-pagination-btn-list ${page === currentPage ? "active-list" : ""} ${page.type === "ellipsis" ? "ellipse" : ""}`}
                  >
                    {typeof page === "number" ? page : <img src={Icons.extraIcon} alt="..." className="department-extra-icon" />}
                  </button>
                ))}
                <button onClick={() => handlePrevNext("next")} disabled={currentPage === totalPages} className="department-pagination-next-list">
                  <img src={Icons.rightArrow} alt=">" />
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdditionalConsumableList;
